<template>
  <div>
    <div class="main_content wrap">
      <Sidebar :inidata="dataInitial" />
      <RightNav :inidata="dataInitial"></RightNav>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import RightNav from '@/components/RightNav'

export default {
  components: { Sidebar, RightNav },
  data() {
    return {
      cates: null,
      purchaseTypes: null,
      dataInitial: {},
      isShow: false
    }
  },
  beforeMount() {
    var that = this
    this.getRequest('/Information/Index')
      .then((res) => {
        var data = res.data
        if (data.errcode == 0) {
          that.dataInitial = data
          that.isShow = true
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  mounted() {
    sessionStorage.setItem('IndexTab', 'index')
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.main_content {
  display: flex;
  margin-top: 10px;
}
</style>
